import { Button, useMobile } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';

interface DefaultActionsProps {
  onPressDownload: () => void;
}

export default function DefaultActions({
  onPressDownload,
}: DefaultActionsProps) {
  const { t } = useTranslation();
  const isMobile = useMobile();

  return (
    <>
      <div className="d-flex flex-wrap align-items-center " style={{ gap: 12 }}>
        <Button
          text={t(`common:actions.download`)}
          icon="download"
          size="sm"
          outlined
          style={{ width: isMobile ? '90%' : 123 }}
          disabled={false}
          onClick={onPressDownload}
        />
      </div>
    </>
  );
}
